import a, { css as t } from "styled-components";
var i = /* @__PURE__ */ a.div.withConfig({
  displayName: "tableContainer__TableContainer",
  componentId: "sc-119aa1v-0"
})(["&.TableContainer{", ";}", ""], function(e) {
  var n = e.theme.componentStyles;
  return t(n);
}, function(e) {
  return `
    box-sizing: ` + e.theme.components.dataTable.TableContainer.boxSizing + `;
    display: ` + e.theme.components.dataTable.TableContainer.display + `;
    flex-direction: ` + e.theme.components.dataTable.TableContainer.flexDirection + `;
    gap: ` + e.theme.components.dataTable.TableContainer.gap + `;
    `;
});
export {
  i as T
};
